import React, { useState, useContext } from 'react';
import { useDispatch } from '../../store/index.js';
import { useSelector } from '../../store/index.js';
import { useEffect } from 'react';
import loading from "../../utils/Loading.js";
import { Logout, UpdateInfo, SetContractChanged } from '../../store/reducers/auth.js';
import useApi from "../../hooks/useApi.js";
import toast from 'react-hot-toast';
import { ChangePage } from '../../store/reducers/menu.js';
import { showLoading, hideLoading } from '../../store/reducers/load.js';

function JoinColorGameModal() {
    const dispatch = useDispatch();
    const [number, setNumber] = useState(1);
    const [money, setMoney] = useState(1);
    const { colorGameInfo, user, colorGameActive } = useSelector((state) => (state.auth));
    const { depositByUPI, betColorGameAPI } = useApi();
    const greenColor = ['Green', '1', '3', '7', '9'];
    const redColor = ['Red', '2', '4', '6', '8'];
    const purpleColor = ['Violet', '0', '5'];
    const [backgroundColor, setBackgroundColor] = useState('text-white');

    const betColorGame = async () => {
        try {
            if (!colorGameActive) {
                toast.warning("Bet Time out!");
                dispatch(ChangePage(""));
                return;
            }
            dispatch(ChangePage(""));

            dispatch(showLoading({ open: true }));

            const res = await betColorGameAPI(user._id, colorGameInfo, money)

            dispatch(hideLoading());

            if (!res.data?.success) {
                toast.error(res.data.msg);
            } else if (res.data?.success) {
                toast.success(res.data.msg);

                dispatch(SetContractChanged())
                dispatch(UpdateInfo({ balance: res.data.data }))
            }

        } catch {
            loading(false);
            dispatch(ChangePage(""));
            console.log("danger", "connection error");
        }
    }

    useEffect(() => {
        if (greenColor.includes(colorGameInfo.betValue)) {
            setBackgroundColor("text-green-400");
        } else if (redColor.includes(colorGameInfo.betValue)) {
            setBackgroundColor("text-coral-500");
        } else if (purpleColor.includes(colorGameInfo.betValue)) {
            setBackgroundColor("text-purple-800");
        }
    }, [])

    return (
        <div className="modal-overlay fixed inset-0 flex items-center justify-center text-white z-50" style={{ backgroundColor: "rgba(22,22,22,0.8)" }}>
            <div className="fixed inset-0 flex items-center justify-center">
                <div className="flex w-full flex-row justify-center items-center px-4">
                    <div style={{ maxWidth: "600px", maxHeight: '666px', margin: '0 auto' }}
                        className="w-full p-4 sm:p-6 md:p-8 gap-[20px] bg-primary bg-opacity-90 rounded-lg shadow-bottom_2 flex justify-start flex-col items-center">
                        <span className={`text-[24px] ${backgroundColor} font-bold `}>Select {colorGameInfo.betValue}</span>
                        <div className="relative flex flex-col justify-start w-full gap-4">
                            <div className="flex flex-row justify-start items-center">
                                <p className="font-bold text-yellow-300 text-14 leading-20">Amount $</p>
                            </div>
                            <div className='flex flex-row gap-2'>
                                <div className={`text-12 px-2 py-2  text-white font-medium rounded-lg w-16 flex flex-row justify-center gap-45 items-center  ${money == 1 ? 'bg-yellow-300' : 'bg-darkblue-600'}`} onClick={() => setMoney(1)}
                                    style={{ textAlign: 'center', cursor: 'pointer' }}>
                                    <p className='text-white font-bold'>1</p>
                                </div>
                                <div className={`text-12 px-2 py-2  text-white font-medium rounded-lg w-16 flex flex-row justify-center gap-45 items-center  ${money == 5 ? 'bg-yellow-300' : 'bg-darkblue-600'}`} onClick={() => setMoney(5)}
                                    style={{ textAlign: 'center', cursor: 'pointer' }}>
                                    <p className='text-white font-bold'>5</p>
                                </div>
                                <div className={`text-12 px-2 py-2  text-white font-medium rounded-lg w-16 flex flex-row justify-center gap-45 items-center  ${money == 10 ? 'bg-yellow-300' : 'bg-darkblue-600'}`} onClick={() => setMoney(10)}
                                    style={{ textAlign: 'center', cursor: 'pointer' }}>
                                    <p className='text-white font-bold'>10</p>
                                </div>
                                <div className={`text-12 px-2 py-2  text-white font-medium rounded-lg w-16 flex flex-row justify-center gap-45 items-center  ${money == 20 ? 'bg-yellow-300' : 'bg-darkblue-600'}`} onClick={() => setMoney(20)}
                                    style={{ textAlign: 'center', cursor: 'pointer' }}>
                                    <p className='text-white font-bold'>20</p>
                                </div>
                                <div className={`text-12 px-2 py-2  text-white font-medium rounded-lg w-16 flex flex-row justify-center gap-45 items-center  ${money == 50 ? 'bg-yellow-300' : 'bg-darkblue-600'}`} onClick={() => setMoney(50)}
                                    style={{ textAlign: 'center', cursor: 'pointer' }}>
                                    <p className='text-white font-bold'>50</p>
                                </div>
                                <div className={`text-12 px-2 py-2  text-white font-medium rounded-lg w-16 flex flex-row justify-center gap-45 items-center  ${money == 100 ? 'bg-yellow-300' : 'bg-darkblue-600'}`} onClick={() => setMoney(100)}
                                    style={{ textAlign: 'center', cursor: 'pointer' }}>
                                    <p className='text-white font-bold'>100</p>
                                </div>
                            </div>
                            <div className='flex flex-row gap-4 items-center'>
                                <span className='font-bold text-yellow-300'>Bet Amount $ : </span>
                                <div className="text-12 px-3 py-2  text-white font-medium bg-darkblue-600 rounded-lg flex flex-row justify-center gap-45 items-center" onClick={() => setMoney(prev => prev == 1 ? 1 : prev - 1)}
                                    style={{ textAlign: 'center', cursor: 'pointer' }}>
                                    <p className='text-white font-bold'>-</p>
                                </div>
                                <input style={{ textAlign: "center" }} className="bg-gray-700 py-2 px-4 rounded-lg w-16 text-white font-bold outline-none border-white focus:border-white" value={money} onChange={(e) => setMoney(Number(e.target.value))}></input>
                                {
                                    (money < 100) &&
                                    <div className="text-12 px-3 py-2  text-white font-medium bg-darkblue-600 rounded-lg flex flex-row justify-center gap-45 items-center" onClick={() => setMoney(prev => prev + 1)}
                                        style={{ textAlign: 'center', cursor: 'pointer' }}>
                                        <p className='text-white font-bold'>+</p>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="flex flex-row justify-around items-center w-full gap-[30px] w-[231px] pt-2">
                            <button
                                onClick={() => {
                                    dispatch(ChangePage(""))
                                }}
                                className="border-2 py-1 border-yellow-300 font-semibold text-xs px-4 rounded-lg text-yellow-300 inline-flex items-center justify-center"
                            >
                                <span className='text-[16px] py-1'> Cancel </span>
                            </button>
                            <button onClick={() => betColorGame()} className="btn-secondary py-4 px-4 text-xs h-full transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 flex">
                                <span className='text-[16px] py-4'> Confirm </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JoinColorGameModal;